// Guard `avatar sync` cho workspace KHÔNG phải loại dev (card #254, vd Avatar DataHub).
//
// Đứng NGAY sau guard marker trong `syncAction`: không tải pack, không symlink, không merge
// settings/CLAUDE.md, không bật tool, không đăng ký registry — và exit 0 (bỏ qua có chủ đích,
// không phải lỗi). `sync --all` và `avatar update` spawn `avatar sync` từng workspace ⇒ guard
// này cũng là lưới cuối cho 2 đường đó (bộ lọc của `sync --all` chặn trước, không spawn).
import { writeMachineReadableJson } from "./machine-readable-json-output-contract.js";
import { DEV_WORKSPACE_KIND, readWorkspaceMarkerKind } from "./read-workspace-marker-kind.js";
import { log } from "./terminal-logger.js";

/** Mã lý do máy-đọc — cùng kiểu kebab-case với các `reason` của `sync --all`. */
export const NON_DEV_WORKSPACE_REASON = "non-dev-workspace";

export function nonDevWorkspaceSkipMessage(kind: string): string {
  return `Workspace loại '${kind}' (vd Avatar DataHub) — avatar sync không áp dụng, bỏ qua.`;
}

/**
 * Trả `true` khi đã xử lý xong (workspace non-dev ⇒ caller `return` ngay, exit 0).
 * `json` ⇒ đúng 1 dòng JSON trên stdout (luật 4 của hợp đồng máy-đọc).
 */
export function skipSyncForNonDevWorkspaceKind(projectRoot: string, json?: boolean): boolean {
  const kind = readWorkspaceMarkerKind(projectRoot);
  if (kind === DEV_WORKSPACE_KIND) return false;
  if (json) {
    writeMachineReadableJson({
      command: "sync",
      status: "skipped",
      reason: NON_DEV_WORKSPACE_REASON,
      workspace_kind: kind,
      path: projectRoot,
    });
  } else {
    log.info(nonDevWorkspaceSkipMessage(kind));
  }
  return true;
}
